export function caseInsensitiveCompare (a: string, b: string): number {
  const aString = a.toLowerCase()
  const bString = b.toLowerCase()
  return aString > bString ? 1 : (aString < bString ? -1 : 0)
}

export function defaultCompare<T>(a: T, b: T): 0|-1|1 {
  return a > b ? 1 : (a < b ? -1 : 0)
}